<template>

  <section id="sobre-nos" class="d-flex align-items-center sobre-nos">

    <div class="container">

<div class="section-title" data-aos="fade-up">
  <div class="row">
    <h1 data-aos="fade-up">Sobre nós</h1>
    <h5 data-aos="fade-up" data-aos-delay="400">Somos apaixonados por contabilidade, tecnologia e inovação!</h5>
    <h5 data-aos="fade-up" data-aos-delay="400">Desburocratizando processos, gerando economia, agilidade e mostrando que sim</h5>
    <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400"><strong>é possível fazer sua contabilidade online.</strong></h5>
  </div>

  <div class="row">
    <div class="col-md-6 d-flex align-items-stretch mb-4 gap-5" data-aos="fade-left" data-aos-delay="300">
      <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
        <div class="image d-flex justify-content-center mb-4 " data-aos="fade-right" data-aos-delay="150">
          <img src="../assets/img/sigame-socio-edilson2.jpg" alt="" class="img-fluid" style="width: 400px; height: 580px">
        </div>
        <!--<h4 class="title"><strong>Edilson Calegari</strong></h4>-->
        <div style="width: 500px;" data-aos="fade-right" data-aos-delay="150">
          <p>
            <strong>Edilson Calegari</strong><br>
            Contador responsável e técnico<br>
            CRC/PR - 048934/O-4
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-6 d-flex align-items-stretch mb-4 gap-5" data-aos="fade-left" data-aos-delay="300">
      <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
        <div class="image d-flex justify-content-center mb-4 " data-aos="fade-right" data-aos-delay="150">
          <img src="../assets/img/sigame-socio-juliana2.jpg" alt="" class="img-fluid" style="width: 400px; height: 580px">
        </div>
        <!--<h4 class="title"><strong>Edilson Calegari</strong></h4>-->
        <div style="width: 500px;" data-aos="fade-right" data-aos-delay="150">
          <p>
            <strong>Juliana Pagotti</strong><br>
            Contadora responsável<br>
            CRC/PR - 062824/O-2
          </p>
        </div>
      </div>
    </div>

    <div class="padding: 400px;">
      <br>
    </div>

    <h5 class="mb-3" data-aos="fade-up" data-aos-delay="400">Quer nos conhecer melhor?</h5>

    <div class="box-button" data-aos="zoom-in-left" data-aos-delay="200">
      <div >
          <div >
              <a class="btn-contato" style="text-decoration: none; padding: 15px 40px 12px 40px"
                href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20conhecer%20melhor.">
                Entre em contato
              </a>
          </div>
        </div>
    </div>

  </div>

</div>

</div>

  </section>

</template>

<script>
export default {
  name: 'SobreNosComp'
}
</script>

<style scoped lang="scss">
.sobre-nos {
  padding-top: 0;
  background-color: #f7f8fa;
  padding: 9vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#sobre-nos img {
  border-radius: 2%;
  width: 98%;
}

.sobre-nos .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.sobre-nos.content {
  padding: 0;
}

.sobre-nos.content h3 {
  font-weight: 700;
  font-size: 34px;
  color: $color-base;
}

.sobre-nos.content p {
  margin-bottom: 0;
}

.socios {
  padding: 500px 0px 0px 0px;
}

.sobre-nos .btn-contato {
  display: inline-block;
  padding: 15px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: #fff;
  background-color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 220px;
  text-decoration: none;
}

.sobre-nos .btn-contato:hover {
  border: 2px solid $a-color-hover;
  background-color: $a-color-hover;
}

</style>
